// Centralized allowed MUI Chip colors + type guard
// Keeps color validation logic consistent and removes inline inclusion arrays.

// Allowed Chip color values we actually use in the admin panel.
export const ALLOWED_CHIP_COLORS = [
  "default",
  "primary",
  "secondary",
  "error",
  "info",
  "success",
  "warning",
] as const;

export type AllowedChipColor = (typeof ALLOWED_CHIP_COLORS)[number];

export const isAllowedChipColor = (value: unknown): value is AllowedChipColor =>
  typeof value === "string" &&
  (ALLOWED_CHIP_COLORS as readonly string[]).includes(value);

// Safely coerce an arbitrary string to a valid Chip color (fallback to 'default').
export const toSafeChipColor = (value: unknown): AllowedChipColor =>
  isAllowedChipColor(value) ? value : "default";

// Helper to map arbitrary domain color names to chip colors if needed later.
export const mapDomainToChipColor = (
  domainColor: string | null | undefined,
): AllowedChipColor => {
  if (!domainColor) return "default";
  return toSafeChipColor(domainColor);
};
